import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
image:{
    maxWidth:'90%',
    borderRadius:'15px',
    objectFit:'cover',
    boxShadow:'0 0 4px ',
}
}));
